import React from 'react'
import { TweenMax } from 'gsap'
import ClassNames from 'classnames'

const speed = 0.4
const ease = Expo.easeInOut
const delay = 0.1

class WSymbol extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentlyAnimating: true,
    }
    this.start = this.start.bind(this)
    this.next = this.next.bind(this)
    this.reset = this.reset.bind(this)
  }

  componentDidMount() {
    this.start()
  }

  componentWillReceiveProps(newProps) {
    if (newProps.animated && !this.state.currentlyAnimating) {
      this.setState({
        currentlyAnimating: true,
      })
      this.start()
    }
  }

  start() {
    TweenMax.to(this.wEl, speed, {
      left: 0 - (85 + 17),
      delay: delay,
      ease: ease,
      onComplete: this.next,
    })
  }

  next() {
    TweenMax.to(this.wEl, speed, {
      top: 0 - (42 - 14),
      delay: delay,
      ease: ease,
      onComplete: this.reset,
    })
  }

  reset() {
    this.wEl.setAttribute('style', 'left: -85px; top: -42px;')
    if (this.props.animated) {
      this.start()
    } else {
      this.setState({
        currentlyAnimating: false,
      })
    }
  }

  render() {
    return (
      <div
        className={ClassNames({
          W: true,
          ['is-' + this.props.color]: true,
        })}
      >
        <div className="internal">
          <svg
            ref={el => {
              this.wEl = el
            }}
            id="w"
            width="179"
            height="149"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M170 0h9v23h-17v14h-17v14h-17v14h-17v14H94v14H77v14H60v14H43v14H26v14H0v-9h17v-14h17v-14h17V98h17V84h17V70h17V56h17V42h17V28h17V14h17V0z" />
          </svg>
        </div>
      </div>
    )
  }
}

export default WSymbol



// WEBPACK FOOTER //
// ./src/components/w-symbol.js